import React from "react";
import ChangePassword from "../../components/AdminTabs/AdminChangePassword/ChangePassword";

const ChangePasswordPage = () => {
  return (
    <div>
      <ChangePassword />
    </div>
  );
};

export default ChangePasswordPage;
